import { AuthError } from '@aws-amplify/auth';
import { UtilsService } from '../../services/utils';
import { Injectable } from '@angular/core';
import { ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'any',
})
export class AuthUtils {
  constructor(private utilsService: UtilsService) {}

  public processAuthError(e: unknown) {
    if (e instanceof AuthError) {
      if (e.name === 'UserNotFoundException') {
        this.utilsService.showError($localize`User has not been found. Is user e-mail correct?`);
      } else if (e.name === 'UsernameExistsException') {
        this.utilsService.showError($localize`User with this email already exists`);
      } else if (e.name === 'CodeMismatchException') {
        this.utilsService.showError($localize`Wrong code entered`);
      } else {
        this.utilsService.showError($localize`Unexpected error: ${e.name}`);
      }
    } else {
      const message = (e as any).message ?? e;
      this.utilsService.showError($localize`Unexpected error: ${message}`);
    }
  }

  public passwordComplexityValidator(): ValidatorFn {
    return (control) => {
      const value = control.value;

      if (
        !/[a-z]/.test(value) ||
        !/[A-Z]/.test(value) ||
        !/[0-9]/.test(value) ||
        !/[!@#$%\^&*(){}\[\];':",.<>?\/-_+=]/.test(value)
      ) {
        return { passwordSymbols: { value: control.value } };
      }

      return null;
    };
  }

  public passwordsMatch(): ValidatorFn {
    return (control) => {
      const password = control.get('password');
      const confirmPassword = control.get('confirmPassword');
      if (!password || !confirmPassword) {
        return null;
      }
      return password.value !== confirmPassword.value
        ? {
            passwordsMatch: {
              password: password.value,
              confirmPassword: confirmPassword.value,
            },
          }
        : null;
    };
  }
}
